export default "__VITE_ASSET__CJrMYJ1x__"